import memeService from "../../../../../services/MemeService";
import BlueButton from "../../../../common/BlueButton/BlueButton";
import { useTranslation } from "react-i18next";
const ReportImageFrame = ({
    setMetaData,
    setIsReporting,
    metaData,
    setReasonValue,
    setIsReportedButtonOff,
    isReportedButtonOff,
    reasonValue,
}) => {
    const { t } = useTranslation("templatesPage");

    const backButtonClicked = () => {
        setIsReporting(false);
        setMetaData(null);
        setIsReportedButtonOff(false);
    };

    const reportDisplayButton = !isReportedButtonOff ? (
        <BlueButton
            text={t("browesPageReportImageButton")}
            isCenter={true}
            isDark={true}
            isGray={isReportedButtonOff}
            onClick={async () => {
                setIsReportedButtonOff(true);
                await memeService.createOrUpdateReportImage(
                    metaData.templateId,
                    reasonValue,
                    metaData.uploader,
                    metaData.url,
                );
                setIsReportedButtonOff(false);
            }}
        />
    ) : (
        <p className="reportText">{t("browesPageThanksForReport")}</p>
    );

    let content = (
        <>
            <div className="ImageSelectorBackButtonContainer">
                <button
                    className="ImageSelectorBackButton"
                    onClick={backButtonClicked}
                >
                    X
                </button>
            </div>
            <div className="reportFlagContainer">
                <p className="reportFlag" onClick={() => setIsReporting(false)}>
                    {t("backButton")}
                </p>
            </div>
            <h3 className="ImageSelectorTitle">
                {t("browesPageReportImageTitle")}
            </h3>
            <hr className="ImageSelectorLineBreak" />
            <br />
            <img
                className="imageGridDisplay"
                src={metaData.thumbnailUrl}
                alt={metaData.title}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/imageNotFound.jpg";
                }}
            />
            <br />
            <p className="reportText">{t("browesPageReportText")}</p>
            <div className="reporterSpanAndSelectorContainer">
                <span className="reportSpanText">
                    {t("browesPageReportReson")}
                </span>
                <select
                    className="reportSelector"
                    name="reason"
                    defaultValue="Inappropriate"
                    onChange={(e) => setReasonValue(e.target.value)}
                >
                    <option value="Inappropriate">
                        {t("browesPageInappropriate")}
                    </option>
                    <option value="Racism">{t("browesPageRacism")}</option>
                    <option value="Pornography">
                        {t("browesPagePornography")}
                    </option>
                </select>
            </div>
            <br />
            {reportDisplayButton}
        </>
    );

    return content;
};

export default ReportImageFrame;
